<template>
  <transition name="animated" mode="out-in">
    <div
      key="main-content"
      v-if="auth"
      class="d-flex flex-fill flex-column justify-content-between"
    >
      <div class="container-fluid main-container">
        <div class="main-nav">
          <div class="d-flex flex-fill align-items-center">
            <img
              :src="$store.state.corporate.logo_preview"
              alt="Logo"
              class="img-fluid max-h-40px rounded-circle"
            />
            <h4 class="mx-3 font-weight-bolder mb-0">
              {{ this.$store.state.corporate.name }}
            </h4>
            <span>
              Latest Update : {{ updateDate | parse("longDateTime") }}
            </span>
          </div>
          <img
            :src="$_config.logo.sm"
            alt="Logo"
            class="img-fluid max-h-30px"
          />
          <button
            @click="logout"
            type="button"
            class="btn btn-icon toolbar-button toolbar-button-icon btn-transparant active"
          >
            <i class="ri-logout-circle-line text-danger"></i>
          </button>
        </div>
      </div>
      <div class="container-fluid main-container flex-fill">
        <div class="row content-inner">
          <div class="col-md-3">
            <div class="card card-custom gutter-b">
              <div class="card-header border-0 min-h-50px">
                <h3 class="card-title font-size-h4 my-0 font-weight-bolder">
                  Sales Order
                </h3>
                <div class="card-toolbar my-0"></div>
              </div>
              <div v-if="mainData.sales" class="card-body py-0">
                <hr class="mt-0" />
                <div
                  class="d-flex align-items-center bg-light py-5 px-8"
                  style="border-radius: 8px"
                >
                  <div class="pr-4 mt-1">
                    <svg
                      width="43"
                      height="42"
                      viewBox="0 0 43 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.3809 28.4374H20.0126C17.6297 28.4374 15.6768 26.4774 15.6768 24.0624C15.6768 23.3449 16.2859 22.7499 17.0205 22.7499C17.7551 22.7499 18.3643 23.3449 18.3643 24.0624C18.3643 25.0249 19.0988 25.8124 20.0126 25.8124H23.3809C24.0797 25.8124 24.6351 25.1999 24.6351 24.4474C24.6351 23.5024 24.3663 23.3624 23.7572 23.1524L18.3643 21.3149C17.2176 20.9299 15.6768 20.1074 15.6768 17.5349C15.6768 15.3474 17.4505 13.5449 19.6184 13.5449H22.9868C25.3697 13.5449 27.3226 15.5049 27.3226 17.9199C27.3226 18.6374 26.7134 19.2324 25.9788 19.2324C25.2443 19.2324 24.6351 18.6374 24.6351 17.9199C24.6351 16.9574 23.9005 16.1699 22.9868 16.1699H19.6184C18.9197 16.1699 18.3643 16.7824 18.3643 17.5349C18.3643 18.4799 18.633 18.6199 19.2422 18.8299L24.6351 20.6674C25.7818 21.0524 27.3226 21.8749 27.3226 24.4474C27.3226 26.6524 25.5488 28.4374 23.3809 28.4374Z"
                        fill="#00AC4F"
                      ></path>
                      <path
                        d="M21.5 30.1875C20.7654 30.1875 20.1562 29.5925 20.1562 28.875V13.125C20.1562 12.4075 20.7654 11.8125 21.5 11.8125C22.2346 11.8125 22.8438 12.4075 22.8438 13.125V28.875C22.8438 29.5925 22.2346 30.1875 21.5 30.1875Z"
                        fill="#00AC4F"
                      ></path>
                      <path
                        d="M21.4987 39.8125C10.8741 39.8125 2.23828 31.3775 2.23828 21C2.23828 10.6225 10.8741 2.1875 21.4987 2.1875C22.2333 2.1875 22.8424 2.7825 22.8424 3.5C22.8424 4.2175 22.2333 4.8125 21.4987 4.8125C12.3612 4.8125 4.92578 12.075 4.92578 21C4.92578 29.925 12.3612 37.1875 21.4987 37.1875C30.6362 37.1875 38.0716 29.925 38.0716 21C38.0716 20.2825 38.6808 19.6875 39.4154 19.6875C40.1499 19.6875 40.7591 20.2825 40.7591 21C40.7591 31.3775 32.1233 39.8125 21.4987 39.8125Z"
                        fill="#00AC4F"
                      ></path>
                      <path
                        d="M37.6258 13.5625H30.4592C29.7246 13.5625 29.1154 12.9675 29.1154 12.25V5.25C29.1154 4.5325 29.7246 3.9375 30.4592 3.9375C31.1937 3.9375 31.8029 4.5325 31.8029 5.25V10.9375H37.6258C38.3604 10.9375 38.9696 11.5325 38.9696 12.25C38.9696 12.9675 38.3604 13.5625 37.6258 13.5625Z"
                        fill="#00AC4F"
                      ></path>
                      <path
                        d="M30.4565 13.564C30.116 13.564 29.7756 13.4415 29.5069 13.179C28.9873 12.6715 28.9873 11.8315 29.5069 11.324L38.4652 2.57398C38.9848 2.06648 39.8448 2.06648 40.3644 2.57398C40.884 3.08148 40.884 3.92148 40.3644 4.42898L31.406 13.179C31.1373 13.4415 30.7969 13.564 30.4565 13.564Z"
                        fill="#00AC4F"
                      ></path>
                    </svg>
                  </div>
                  <div class="flex-fill">
                    <span class="d-block mb-2 font-weight-bold">
                      Total Volume Order (M3)
                    </span>
                    <h4 class="mb-0 font-weight-normal">
                      <span class="font-weight-bolder">
                        {{
                          mainData.sales.real.statistic.sum_order_prospect
                            | parse("number")
                        }}
                      </span>
                      M3
                    </h4>
                  </div>
                </div>
              </div>
              <div v-if="mainData.sales" class="card-body p-0">
                <highcharts
                  :constructorType="'chart'"
                  :options="pieHighChart"
                ></highcharts>
              </div>
            </div>
            <div class="card card-custom">
              <div class="card-header border-0 min-h-50px">
                <h3 class="card-title font-size-h4 my-0 font-weight-bolder">
                  Average Selling Price
                  <span class="font-weight-normal">&nbsp;(per M3)</span>
                </h3>
                <div class="card-toolbar my-0"></div>
              </div>
              <div v-if="mainData.selling" class="card-body pt-0">
                <hr class="mt-0" />
                <div
                  class="d-flex align-items-center bg-light-primary py-5 px-8"
                  style="border-radius: 8px"
                >
                  <div class="pr-4 mt-1">
                    <svg
                      width="43"
                      height="42"
                      viewBox="0 0 43 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.3809 28.4374H20.0126C17.6297 28.4374 15.6768 26.4774 15.6768 24.0624C15.6768 23.3449 16.2859 22.7499 17.0205 22.7499C17.7551 22.7499 18.3643 23.3449 18.3643 24.0624C18.3643 25.0249 19.0988 25.8124 20.0126 25.8124H23.3809C24.0797 25.8124 24.6351 25.1999 24.6351 24.4474C24.6351 23.5024 24.3663 23.3624 23.7572 23.1524L18.3643 21.3149C17.2176 20.9299 15.6768 20.1074 15.6768 17.5349C15.6768 15.3474 17.4505 13.5449 19.6184 13.5449H22.9868C25.3697 13.5449 27.3226 15.5049 27.3226 17.9199C27.3226 18.6374 26.7134 19.2324 25.9788 19.2324C25.2443 19.2324 24.6351 18.6374 24.6351 17.9199C24.6351 16.9574 23.9005 16.1699 22.9868 16.1699H19.6184C18.9197 16.1699 18.3643 16.7824 18.3643 17.5349C18.3643 18.4799 18.633 18.6199 19.2422 18.8299L24.6351 20.6674C25.7818 21.0524 27.3226 21.8749 27.3226 24.4474C27.3226 26.6524 25.5488 28.4374 23.3809 28.4374Z"
                        fill="#00AC4F"
                      />
                      <path
                        d="M21.5 30.1875C20.7654 30.1875 20.1562 29.5925 20.1562 28.875V13.125C20.1562 12.4075 20.7654 11.8125 21.5 11.8125C22.2346 11.8125 22.8438 12.4075 22.8438 13.125V28.875C22.8438 29.5925 22.2346 30.1875 21.5 30.1875Z"
                        fill="#00AC4F"
                      />
                      <path
                        d="M21.4987 39.8125C10.8741 39.8125 2.23828 31.3775 2.23828 21C2.23828 10.6225 10.8741 2.1875 21.4987 2.1875C22.2333 2.1875 22.8424 2.7825 22.8424 3.5C22.8424 4.2175 22.2333 4.8125 21.4987 4.8125C12.3612 4.8125 4.92578 12.075 4.92578 21C4.92578 29.925 12.3612 37.1875 21.4987 37.1875C30.6362 37.1875 38.0716 29.925 38.0716 21C38.0716 20.2825 38.6808 19.6875 39.4154 19.6875C40.1499 19.6875 40.7591 20.2825 40.7591 21C40.7591 31.3775 32.1233 39.8125 21.4987 39.8125Z"
                        fill="#00AC4F"
                      />
                      <path
                        d="M37.6258 13.5625H30.4592C29.7246 13.5625 29.1154 12.9675 29.1154 12.25V5.25C29.1154 4.5325 29.7246 3.9375 30.4592 3.9375C31.1937 3.9375 31.8029 4.5325 31.8029 5.25V10.9375H37.6258C38.3604 10.9375 38.9696 11.5325 38.9696 12.25C38.9696 12.9675 38.3604 13.5625 37.6258 13.5625Z"
                        fill="#00AC4F"
                      />
                      <path
                        d="M30.4565 13.564C30.116 13.564 29.7756 13.4415 29.5069 13.179C28.9873 12.6715 28.9873 11.8315 29.5069 11.324L38.4652 2.57398C38.9848 2.06648 39.8448 2.06648 40.3644 2.57398C40.884 3.08148 40.884 3.92148 40.3644 4.42898L31.406 13.179C31.1373 13.4415 30.7969 13.564 30.4565 13.564Z"
                        fill="#00AC4F"
                      />
                    </svg>
                  </div>
                  <div class="flex-fill">
                    <span class="d-block mb-2 font-weight-bold"
                      >Global Average Selling Price (per M3)</span
                    >
                    <h4 class="mb-0 font-weight-normal">
                      Rp.
                      <span class="font-weight-bolder">{{
                        mainData["selling"].real.average_selling_price
                          | parse("number")
                      }}</span>
                    </h4>
                  </div>
                </div>
                <template>
                  <div
                    class="flex-fill"
                    v-if="mainData['selling'].build.length > 1"
                  >
                    <carousel loop :perPage="1" paginationPosition="bottom">
                      <slide
                        v-for="(c, i) in mainData['selling'].build"
                        :key="i + '-data-selling'"
                      >
                        <table
                          class="table table-head-custom table-vertical-center table-head-bg table-borderless mb-0"
                        >
                          <thead>
                            <tr class="bg-transparent">
                              <th
                                class="bg-transparent font-weight-light font-size-lg pb-0 pl-0 nowrap-table"
                              >
                                UNIT PRODUKSI
                              </th>
                              <th
                                class="bg-transparent font-weight-light font-size-lg pb-0 pr-0 text-right nowrap-table"
                              >
                                HARGA RATA-RATA
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(d, j) in c">
                              <tr :key="j + '-selling'">
                                <td class="pl-0">
                                  <div class="d-flex align-items-center">
                                    <div
                                      class="symbol symbol-50 symbol-light mr-4"
                                    >
                                      <span class="symbol-label">
                                        <span
                                          class="symbol-label font-size-md"
                                          >{{ d.production_unit_code }}</span
                                        >
                                      </span>
                                    </div>
                                    <div>
                                      <span
                                        class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-md"
                                        >{{ d.production_unit_name }}</span
                                      >
                                      <!-- <span class="text-muted font-weight-bold d-block font-size-sm">{{ d.total_order }} Order</span> -->
                                    </div>
                                  </div>
                                </td>
                                <td class="pr-0 nowrap-table">
                                  <span
                                    class="label label-xl min-h-40px w-100 label-light label-pill font-weight-bolder label-inline"
                                    >{{
                                      d.average_price | parse("money")
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </slide>
                    </carousel>
                  </div>
                  <div
                    v-else
                    class="flex-fill pr-3 small-scroll"
                    style="
                      overflow-y: auto;
                      overflow-x: hidden;
                      margin-right: -0.75rem;
                    "
                  >
                    <table
                      class="table table-head-custom table-vertical-center table-head-bg table-borderless"
                    >
                      <thead>
                        <tr class="bg-transparent">
                          <th
                            class="bg-transparent font-weight-light font-size-lg pb-0 pl-0 nowrap-table"
                          >
                            UNIT PRODUKSI
                          </th>
                          <th
                            class="bg-transparent font-weight-light font-size-lg pb-0 pr-0 text-right nowrap-table"
                          >
                            HARGA RATA-RATA
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(d, i) in mainData['selling'].build[0]"
                        >
                          <tr :key="i + '-selling'">
                            <td class="pl-0">
                              <div class="d-flex align-items-center">
                                <div class="symbol symbol-50 symbol-light mr-4">
                                  <span class="symbol-label">
                                    <span class="symbol-label font-size-md">{{
                                      d.production_unit_code
                                    }}</span>
                                  </span>
                                </div>
                                <div>
                                  <span
                                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-md"
                                    >{{ d.production_unit_name }}</span
                                  >
                                  <!-- <span class="text-muted font-weight-bold d-block font-size-sm">{{ d.total_order }} Order</span> -->
                                </div>
                              </div>
                            </td>
                            <td class="pr-0 nowrap-table">
                              <span
                                class="label label-xl min-h-40px w-100 label-light label-pill font-weight-bolder label-inline"
                                >{{ d.average_price | parse("money") }}</span
                              >
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <span class="">*data akumulasi dari sales order</span>
                </template>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card card-custom gutter-b">
              <div class="card-header border-0 min-h-50px">
                <h3 class="card-title font-size-h4 my-0 font-weight-bolder">
                  Rencana &amp; Realisasi Produksi
                  <span class="font-weight-normal">&nbsp;(per M3)</span>
                </h3>
                <div class="card-toolbar my-0"></div>
              </div>
              <div v-if="mainData.production" class="card-body pt-0">
                <hr class="mt-0" />
                <div class="row py-0" style="min-height: 420px">
                  <div class="col-8 pr-0">
                    <template v-if="mainData['production']">
                      <template v-if="mainData['production'].build.length > 1">
                        <carousel
                          loop
                          :perPage="1"
                          paginationPosition="bottom-overlay"
                        >
                          <slide
                            v-for="(c, i) in mainData['production']"
                            :key="i + '-chart-production'"
                          >
                            <apexchart
                              type="bar"
                              height="100%"
                              :options="barProductionOption"
                              :series="c"
                            ></apexchart>
                          </slide>
                        </carousel>
                      </template>
                      <template v-else>
                        <apexchart
                          type="bar"
                          height="100%"
                          :options="barProductionOption"
                          :series="mainData['production'].build[0]"
                        ></apexchart>
                      </template>
                    </template>
                  </div>
                  <div class="col-4 pl-0">
                    <div
                      class="d-flex align-items-center bg-light py-5 px-8 mb-3"
                      style="border-radius: 8px"
                    >
                      <div class="pr-4 mt-1">
                        <svg
                          width="43"
                          height="42"
                          viewBox="0 0 43 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.3809 28.4374H20.0126C17.6297 28.4374 15.6768 26.4774 15.6768 24.0624C15.6768 23.3449 16.2859 22.7499 17.0205 22.7499C17.7551 22.7499 18.3643 23.3449 18.3643 24.0624C18.3643 25.0249 19.0988 25.8124 20.0126 25.8124H23.3809C24.0797 25.8124 24.6351 25.1999 24.6351 24.4474C24.6351 23.5024 24.3663 23.3624 23.7572 23.1524L18.3643 21.3149C17.2176 20.9299 15.6768 20.1074 15.6768 17.5349C15.6768 15.3474 17.4505 13.5449 19.6184 13.5449H22.9868C25.3697 13.5449 27.3226 15.5049 27.3226 17.9199C27.3226 18.6374 26.7134 19.2324 25.9788 19.2324C25.2443 19.2324 24.6351 18.6374 24.6351 17.9199C24.6351 16.9574 23.9005 16.1699 22.9868 16.1699H19.6184C18.9197 16.1699 18.3643 16.7824 18.3643 17.5349C18.3643 18.4799 18.633 18.6199 19.2422 18.8299L24.6351 20.6674C25.7818 21.0524 27.3226 21.8749 27.3226 24.4474C27.3226 26.6524 25.5488 28.4374 23.3809 28.4374Z"
                            fill="#00AC4F"
                          ></path>
                          <path
                            d="M21.5 30.1875C20.7654 30.1875 20.1562 29.5925 20.1562 28.875V13.125C20.1562 12.4075 20.7654 11.8125 21.5 11.8125C22.2346 11.8125 22.8438 12.4075 22.8438 13.125V28.875C22.8438 29.5925 22.2346 30.1875 21.5 30.1875Z"
                            fill="#00AC4F"
                          ></path>
                          <path
                            d="M21.4987 39.8125C10.8741 39.8125 2.23828 31.3775 2.23828 21C2.23828 10.6225 10.8741 2.1875 21.4987 2.1875C22.2333 2.1875 22.8424 2.7825 22.8424 3.5C22.8424 4.2175 22.2333 4.8125 21.4987 4.8125C12.3612 4.8125 4.92578 12.075 4.92578 21C4.92578 29.925 12.3612 37.1875 21.4987 37.1875C30.6362 37.1875 38.0716 29.925 38.0716 21C38.0716 20.2825 38.6808 19.6875 39.4154 19.6875C40.1499 19.6875 40.7591 20.2825 40.7591 21C40.7591 31.3775 32.1233 39.8125 21.4987 39.8125Z"
                            fill="#00AC4F"
                          ></path>
                          <path
                            d="M37.6258 13.5625H30.4592C29.7246 13.5625 29.1154 12.9675 29.1154 12.25V5.25C29.1154 4.5325 29.7246 3.9375 30.4592 3.9375C31.1937 3.9375 31.8029 4.5325 31.8029 5.25V10.9375H37.6258C38.3604 10.9375 38.9696 11.5325 38.9696 12.25C38.9696 12.9675 38.3604 13.5625 37.6258 13.5625Z"
                            fill="#00AC4F"
                          ></path>
                          <path
                            d="M30.4565 13.564C30.116 13.564 29.7756 13.4415 29.5069 13.179C28.9873 12.6715 28.9873 11.8315 29.5069 11.324L38.4652 2.57398C38.9848 2.06648 39.8448 2.06648 40.3644 2.57398C40.884 3.08148 40.884 3.92148 40.3644 4.42898L31.406 13.179C31.1373 13.4415 30.7969 13.564 30.4565 13.564Z"
                            fill="#00AC4F"
                          ></path>
                        </svg>
                      </div>
                      <div class="flex-fill">
                        <span class="d-block mb-2 font-weight-bold">
                          Total Rencana Produksi
                        </span>
                        <h4 class="mb-0 font-weight-normal">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800; color: #8950fc"
                          >
                            {{
                              mainData["production"].real.statistic.schedule
                                | parse("number")
                            }}
                          </span>
                          M3
                        </h4>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-start bg-light py-5 px-8 mb-3"
                    >
                      <div class="flex-fill">
                        <span class="d-block mb-2 font-weight-bold">
                          Ralisasi
                        </span>
                        <h4 class="mb-0 font-weight-normal text-success">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800"
                          >
                            {{
                              mainData["production"].real.statistic.actual
                                | parse("number")
                            }}
                          </span>
                          M3
                        </h4>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-start bg-light py-5 px-8 mb-3"
                    >
                      <div class="flex-fill">
                        <span class="d-block mb-2 font-weight-bold">
                          Sisa
                        </span>
                        <h4 class="mb-0 font-weight-normal">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800"
                          >
                            {{
                              mainData["production"].real.statistic.remaining
                                | parse("number")
                            }}
                          </span>
                          M3
                        </h4>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-start bg-light py-5 px-8 mb-3"
                    >
                      <div class="flex-fill">
                        <span class="d-block mb-2 font-weight-bold">
                          Dibatalkan
                        </span>
                        <h4 class="mb-0 font-weight-normal text-danger">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800"
                          >
                            {{
                              mainData["production"].real.statistic.cancel
                                | parse("number")
                            }}
                          </span>
                          M3
                        </h4>
                      </div>
                    </div>

                    <!-- <div
                      class="d-flex align-items-center bg-light py-5 px-3"
                      style="border-radius: 8px"
                    >
                      <div class="flex-fill text-center">
                        <span class="d-block mb-2 font-weight-bold">
                          Ralisasi
                        </span>
                        <h4 class="mb-0 font-weight-normal text-success">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800"
                          >
                            {{
                              mainData["production"].real.statistic.actual
                                | parse("number")
                            }}
                          </span>
                          M3
                        </h4>
                      </div>
                      <div class="flex-fill text-center">
                        <span class="d-block mb-2 font-weight-bold">
                          Sisa
                        </span>
                        <h4 class="mb-0 font-weight-normal">
                          <span
                            class="font-weight-bolderX"
                            style="font-weight: 800"
                            >{{
                              mainData["production"].real.statistic.remaining
                                | parse("number")
                            }}</span
                          >
                          M3
                        </h4>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-custom min-h-450px">
              <div class="card-header border-0 min-h-50px">
                <h3 class="card-title font-size-h4 my-0 font-weight-bolder">
                  Material Stock
                </h3>
                <div class="card-toolbar my-0"></div>
              </div>
              <div v-if="mainData.material" class="card-body pt-0">
                <hr class="mt-0" />
                <div class="row py-0 min-h-400px">
                  <div class="col-6 pr-0">
                    <template v-if="mainData['material']">
                      <template v-if="mainData['material'].build.length > 1">
                        <carousel
                          loop
                          :perPage="1"
                          paginationPosition="bottom-overlay"
                        >
                          <slide
                            v-for="(c, i) in mainData['material'].build"
                            :key="i + '-chart-material'"
                          >
                            <apexchart
                              type="bar"
                              height="100%"
                              :options="{
                                ...barMaterialOption,
                                ...{ colors: materialColor },
                              }"
                              :series="c"
                            ></apexchart>
                          </slide>
                        </carousel>
                      </template>
                      <template v-else>
                        <apexchart
                          type="bar"
                          height="100%"
                          :options="{
                            ...barMaterialOption,
                            ...{ colors: materialColor },
                          }"
                          :series="mainData['material'].build[0]"
                        ></apexchart>
                      </template>
                    </template>
                  </div>
                  <div class="col-6 pl-0">
                    <template
                      v-if="
                        mainData['material-single'] &&
                        mainData['material-single'].length
                      "
                    >
                      <carousel
                        v-bind:autoplay="true"
                        v-bind:loop="true"
                        v-bind:autoplayTimeout="15000"
                        :perPage="1"
                        paginationPosition="bottom-overlay"
                      >
                        <slide
                          v-for="(c, i) in mainData['material-single']"
                          :key="i + '-chart-material-single'"
                        >
                          <apexchart
                            type="bar"
                            height="100%"
                            :options="{
                              ...singleMaterialStockOption,
                              ...{
                                title: { text: c.title, style: titleStyle },
                              },
                            }"
                            :series="c.data"
                          ></apexchart>
                        </slide>
                      </carousel>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <template v-if="mainData['fuel']">
              <div
                class="card card-custom gutter-b"
                v-if="
                  mainData['fuel'].real.data &&
                  mainData['fuel'].real.data.length
                "
              >
                <carousel
                  v-bind:autoplay="true"
                  v-bind:loop="true"
                  v-bind:autoplayTimeout="15000"
                  :perPage="1"
                  paginationPosition="bottom-overlay"
                  style="height: max-content !important"
                >
                  <slide
                    v-for="(c, i) in mainData['fuel'].real.data"
                    :key="i + '-fuel-index-m3-adwajiding'"
                  >
                    <div class="card-header border-0 min-h-50px">
                      <h3
                        class="card-title font-size-h4 my-0 font-weight-bolder"
                      >
                        Average Fuel Index
                        <span class="font-weight-normal">&nbsp;(L/M3)</span>
                        -
                        {{ c.name }}
                      </h3>
                      <div class="card-toolbar my-0"></div>
                    </div>
                    <div v-if="c" class="card-body py-0">
                      <hr class="mt-0" />
                      <div
                        class="text-center bg-light py-3 px-4 gutter-b"
                        style="border-radius: 8px"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <!-- <div class="d-flex align-items-center">
                            <span>Average Index</span>
                            <span class="font-weight-bold pl-2 font-size-h5">{{ c.average_index | parse('number') }}</span>
                          </div> -->
                          <div class="d-flex align-items-center">
                            <span>Target Index</span>
                            <span class="font-weight-bold pl-2 font-size-h5">{{
                              c.target_index
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <template v-if="c.data.length">
                        <div class="row">
                          <template v-for="(d, i) in c.data">
                            <div :key="i + '-data-fuel-index-m3'" class="col-6">
                              <div
                                :style="{ backgroundColor: d.config }"
                                class="text-center pt-3 gutter-b"
                                style="border-radius: 8px"
                              >
                                <h1 style="font-weight: 800">
                                  {{ d.average_index | parse("number") }}
                                </h1>
                                <h6
                                  style="font-weight: 600"
                                  class="my-2"
                                  hidden
                                >
                                  {{ d.liter | parse("number") }} /
                                  {{ d.volume | parse("number") }}
                                </h6>
                                <div
                                  class="bg-light py-3"
                                  style="border-radius: 0 0 7px 7px"
                                >
                                  <span>{{ d.production_unit_name }}</span>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </slide>
                </carousel>
              </div>
            </template>
            <div class="card card-custom">
              <div class="card-header border-0 min-h-50px">
                <h3 class="card-title font-size-h4 my-0 font-weight-bolder">
                  Equipment
                </h3>
                <div class="card-toolbar my-0"></div>
              </div>
              <div v-if="mainData.equipment" class="card-body py-0">
                <hr class="mt-0" />
                <div class="row no-gutters" style="margin: 0 -0.25rem">
                  <template v-for="(d, i) in mainData['equipment'].real.data">
                    <div :key="i + '-equipment'" class="col-6 px-1 pb-2">
                      <div
                        class="text-center bg-light py-3 px-4"
                        style="border-radius: 8px"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span>{{ d.name }}</span>
                          <span class="font-weight-bold pl-2 font-size-h5">{{
                            d.count | parse("number")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="">
                  <hr class="mbX-0" />
                  <carousel
                    v-bind:autoplay="true"
                    v-bind:loop="true"
                    v-bind:autoplayTimeout="15000"
                    :perPage="1"
                    paginationPosition="bottom-overlay"
                  >
                    <slide
                      v-for="(c, i) in mainData['equipment'].build"
                      :key="i + '-data-equipment'"
                    >
                      <apexchart
                        type="bar"
                        height="280"
                        :options="{
                          ...barEquipmentOption,
                          ...{
                            title: {
                              text: c.title,
                              style: titleEquipmentStyle,
                            },
                          },
                        }"
                        :series="c.data"
                      ></apexchart>
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      key="login-content"
      v-else
      class="d-flex flex-fill flex-column justify-content-center align-items-center"
    >
      <div class="login-container">
        <login-overlay />
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";
moment.locale("id");
export default {
  name: "home-dashboard",
  components: {
    LoginOverlay: () => import("@/default-page/login-overlay.vue"),
  },
  data() {
    return {
      configForm: {},
      chunkSize: null,
      updateDate: null,
      mainData: {},
      titleStyle: {
        fontSize: "15px",
        fontWeight: "800",
        fontFamily: 'Poppins,Helvetica,"sans-serif"',
        color: "#272727",
      },
      titleEquipmentStyle: {
        fontSize: "12px",
        fontWeight: "600",
        fontFamily: 'Poppins,Helvetica,"sans-serif"',
        color: "#272727",
      },
      materialColor: [
        "#1DCDC4", // Fuel
        "#9069FF", // Cement
        "#F64E60", // Sand
        "#FFA800", // Split
        "#00AC4F", // Admixture
        "#A6D2FF", // Fly ash
        "#008ffb", // Water
      ],
      materialColorDark: [
        "#16ADA5", // Fuel
        "#6D4DC6", // Cement
        "#BA3846", // Sand
        "#D38B00", // Split
        "#279358", // Admixture
        "#88ACD0", // Fly ash
        "#007bd3", // Water
      ],
      api: [
        {
          id: "sales",
          endpoint: "dashboard/sales/statistic",
          build: "pieSales",
        },
        {
          id: "selling",
          endpoint: "dashboard/sales/average-selling-price",
          build: "dataSelling",
        },
        {
          id: "production",
          endpoint: "dashboard/production",
          build: "barProduction",
        },
        {
          id: "material",
          endpoint: "dashboard/inventory/material-stock",
          build: "barMaterial",
        },
        {
          id: "fuel",
          endpoint: "dashboard/fuel/volume-liter",
          build: "dataFuel",
        },
        {
          id: "equipment",
          endpoint: "dashboard/equipment/statisctic-availability",
          build: "barEquipment",
        },
      ],
      pieHighChart: {
        chart: {
          backgroundColor: "#FFF",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: "80%",
        },
        colors: [],
        title: {
          text: undefined,
        },
        plotOptions: {
          pie: {
            shadow: false,
            allowPointSelect: false,
            cursor: "pointer",
            showInLegend: true,
            dataLabels: {
              enabled: true,
              alignTo: "plotEdges",
              formatter: function () {
                let text = this.percentage.toFixed(1) + "%" + "<br>";
                text += this.y > 0 ? Number(this.y).toLocaleString() + " M3" + "<br>" : ""; text += this.key;
                return text;
              },
            },
          },
        },
        tooltip: {
          valueSuffix: " M3",
        },
        legend: {
          enabled: true,
          squareSymbol: true,
          symbolRadius: 8,
        },
        series: [],
      },
      barProductionOption: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: ["#56D9D3", "#E0E8F0"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "90%",
            dataLabels: {
              position: "bottom",
            },
          },
        },
        xaxis: {
          type: "category",
          tickAmount: "dataPoints",
          // max: 10000,
          logarithmic: false,
          forceNiceScale: true,
          labels: {
            show: false,
            trim: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: true,
            hideOverlappingLabels: false,
            forceNiceScale: true,
            trim: false,
            align: "left",
            style: {
              fontSize: "13px",
              cssClass: "apexcharts-yaxis-label",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        dataLabels: {
          textAnchor: "start",
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            return Number(
              w.config.series[seriesIndex].data[dataPointIndex].y
            ).toLocaleString();
          },
          style: {
            fontWeight: 800,
            colors: ["#000"],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString() + " M3";
            },
          },
          shared: true,
          intersect: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
          fontWeight: 400,
          itemMargin: {
            horizontal: 10,
            vertical: 0,
          },
          markers: {
            width: 16,
            height: 16,
          },
        },
        noData: {
          text: "Loading Data",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined,
          },
        },
      },
      singleMaterialStockOption: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false,
          },
        },
        colors: ["#56D9D3", "#fff"],
        stroke: {
          width: 1,
          colors: ["#dbdbdb"],
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "90%",
            dataLabels: {
              position: "bottom",
            },
          },
        },
        xaxis: {
          type: "category",
          tickAmount: "dataPoints",
          max: 100,
          logarithmic: false,
          forceNiceScale: true,
          labels: {
            show: false,
            trim: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: true,
            hideOverlappingLabels: false,
            forceNiceScale: true,
            trim: false,
            align: "left",
            style: {
              fontSize: "13px",
              cssClass: "apexcharts-yaxis-label",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        dataLabels: {
          textAnchor: "start",
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            let filled = w.config.series[0].data[dataPointIndex];
            let unfilled = w.config.series[1].data[dataPointIndex];

            if (seriesIndex == 0) {
              /** Filled */
              return filled.y > unfilled.y
                ? Number(filled.stock).toLocaleString()
                : "";
            } else {
              /** Un Filled */
              return filled.y > unfilled.y
                ? ""
                : Number(filled.stock).toLocaleString();
            }
          },
          style: {
            fontWeight: 800,
            colors: ["#000"],
          },
        },
        tooltip: {
          y: {
            formatter: function (val, data) {
              // dataPointIndex
              // seriesIndex
              // var item = data.series[data.dataPointIndex];
              const dataItem =
                data.w.globals.initialSeries[data.seriesIndex].data[
                data.dataPointIndex
                ];
              // const dataItem = data.series[data.seriesIndex][data.dataPointIndex]
              // console.log(dataItem);
              // return 10;

              if (data.seriesIndex === 0) {
                return Number(dataItem.quantity).toLocaleString() + " %";
              } else {
                return Number(dataItem.y).toLocaleString() + " %";
              }
            },
          },
          // custom: function({series, seriesIndex, dataPointIndex, w}) {
          //   var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

          //   return '<ul>' +
          //   '<li><b>Price</b>: ' + data.x + '</li>' +
          //   '<li><b>Number</b>: ' + data.y + '</li>' +
          //   '<li><b>Product</b>: \'' + data.product + '\'</li>' +
          //   '<li><b>Info</b>: \'' + data.info + '\'</li>' +
          //   '<li><b>Site</b>: \'' + data.site + '\'</li>' +
          //   '</ul>';
          // },
          shared: true,
          intersect: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
          fontWeight: 400,
          itemMargin: {
            horizontal: 10,
            vertical: 0,
          },
          markers: {
            width: 16,
            height: 16,
          },
        },
        noData: {
          text: "Loading Data",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined,
          },
        },
      },
      barMaterialOption: {
        chart: {
          type: "bar",
          stacked: true,
          // stackType: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            // barHeight: '90%',
            dataLabels: {
              position: "center",
            },
          },
        },
        yaxis: {
          type: "category",
          tickAmount: 6,
          forceNiceScale: true,
          logarithmic: false,
          labels: {
            show: false,
            trim: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: true,
            hideOverlappingLabels: false,
            trim: false,
            align: "left",
            style: {
              fontSize: "13px",
              cssClass: "apexcharts-yaxis-label",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        dataLabels: {
          enabled: false,
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            return Number(
              w.config.series[seriesIndex].data[dataPointIndex].y
            ).toLocaleString();
          },
          style: {
            fontWeight: 800,
            colors: ["#000"],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString();
            },
          },
          shared: true,
          intersect: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "left",
          fontSize: "12px",
          fontWeight: 400,
          offsetX: -40,
          // offsetY: 15,
          itemMargin: {
            horizontal: 10,
            vertical: 0,
          },
          markers: {
            width: 16,
            height: 16,
            offsetY: 3,
          },
        },
        noData: {
          text: "Loading Data",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined,
          },
        },
      },
      barMaterialSingleOption: {
        chart: {
          type: "bar",
          width: "100%",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        xaxis: {
          type: "category",
          labels: {
            show: false,
            trim: false,
            style: {
              colors: ["#B5B5C3"],
            },
          },
          axisBorder: {
            show: false,
            color: "#242424",
            height: 2,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: true,
            hideOverlappingLabels: false,
            trim: false,
            align: "left",
            style: {
              fontSize: "13px",
              cssClass: "apexcharts-yaxis-label",
            },
          },
          axisBorder: {
            show: false,
            color: "#f3f6f9",
          },
          axisTicks: {
            show: false,
          },
        },
        grid: {
          show: false,
          borderColor: "#f3f6f9",
          yaxis: {
            lines: {
              show: false,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        dataLabels: {
          textAnchor: "start",
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            return Number(val).toLocaleString();
          },
          style: {
            fontWeight: 800,
            colors: ["#000"],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString() + " M3";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          fontSize: "14px",
          fontWeight: 600,
          offsetX: -20,
          offsetY: 15,
          itemMargin: {
            horizontal: 10,
            vertical: 0,
          },
          markers: {
            width: 16,
            height: 16,
            offsetY: 3,
          },
        },
        noData: {
          text: "Loading Data",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined,
          },
        },
      },
      barEquipmentOption: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: ["#56D9D3", "#F64E60"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "90%",
            dataLabels: {
              position: "bottom",
            },
          },
        },
        xaxis: {
          type: "category",
          tickAmount: "dataPoints",
          // max: 10000,
          logarithmic: false,
          forceNiceScale: true,
          labels: {
            show: false,
            trim: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: true,
            hideOverlappingLabels: false,
            forceNiceScale: true,
            trim: false,
            align: "left",
            style: {
              fontSize: "13px",
              cssClass: "apexcharts-yaxis-label",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        dataLabels: {
          textAnchor: "start",
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            return Number(
              w.config.series[seriesIndex].data[dataPointIndex].y
            ).toLocaleString();
          },
          style: {
            fontWeight: 800,
            colors: ["#000"],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString();
            },
          },
          shared: true,
          intersect: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "left",
          fontSize: "14px",
          fontWeight: 400,
          itemMargin: {
            horizontal: 10,
            vertical: 0,
          },
          markers: {
            width: 12,
            height: 12,
          },
        },
        noData: {
          text: "Loading Data",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined,
          },
        },
      },
    };
  },
  computed: {
    auth() {
      return this.$store.state.profile;
    },
  },
  mounted() {
    setInterval(() => {
      if (this.$store.state.profile) this.getApi();
    }, 1000 * 60 * 15);
  },
  watch: {
    auth: {
      deep: true,
      immediate: true,
      handler(e) {
        if (e) {
          if (this.$store.state.profile) this.getApi();
        }
      },
    },
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$store.replaceState({ profile: null });
    },
    getApi(filter = null) {
      for (let i = 0; i < this.api.length; i++) {
        const e = this.api[i];
        //filter = { date: ['2023-11-01', '2023-12-30'] }
        this.$_api.get(e.endpoint, filter)
          .then((res) => {
            if (res)
              this.$set(this.mainData, e.id, e.build ? { build: this[e.build](res.data), real: res.data } : res.data);
          })
          .catch((err) => {
            console.log(err);
            // this.$_alert.error(err, 'Error API: \n' + e.endpoint)
          });
      }
      this.updateDate = new Date();
    },
    barProduction(data) {
      let temp = this.splitIntoChunk(data.data, this.chunkSize);
      let result = [];
      for (let i = 0; i < temp.length; i++) {
        // pagination
        const e = temp[i];
        const realization = e.map((z) => {
          return { x: [z.production_unit_name], y: z.actual };
        });
        const remaining = e.map((z) => {
          return { x: [z.production_unit_name], y: z.remaining };
        });
        result[i] = [
          { name: "Sudah Diproduksi", data: realization },
          { name: "Belum Diproduksi", data: remaining },
        ];
      }
      return result;
    },
    barMaterial(data) {
      let temp = this.splitIntoChunk(data.data, this.chunkSize);
      let result = [];
      let subresult = [];
      const materialList = data.data.length
        ? data.data[0].material_stock.map((x) => x.material_category_name)
        : [];
      for (let i = 0; i < temp.length; i++) {
        // pagination
        const e = temp[i];
        let tempMaterial = [];
        for (let j = 0; j < materialList.length; j++) {
          const f = materialList[j];
          let material = e.map((a) => {
            return {
              x: a.production_unit_name,
              y: a.material_stock.filter(
                (b) => b.material_category_name === f
              )[0].quantity,
            };
          });
          tempMaterial.push({ name: f, data: material });
        }
        result[i] = tempMaterial;
      }

      for (let k = 0; k < data.data.length; k++) {
        const g = data.data[k];
        const singleMaterial = g.material_stock.map((z) => {
          return {
            x: z.material_category_name,
            y: z.quantity,
            stock: z.stock,
            quantity: z.quantity,
          };
        });

        let filled = [];
        let unfilled = [];
        const max = 100;

        let i = 0;
        for (let percent of singleMaterial) {
          let fill = percent.y > max ? max : percent.y;
          let unfill = percent.y > max ? 0 : max - percent.y;

          filled.push({
            quantity: percent.quantity,
            x: percent.x,
            y: fill,
            fill: {
              opacity: 0.1,
            },
            stock: percent.stock || 0,
            fillColor: percent.y > 100 ? this.materialColorDark[i] : this.materialColor[i],
          });
          unfilled.push({
            quantity: percent.quantity,
            x: percent.x,
            y: unfill,
            stock: percent.stock || 0,
            fillColor: "#fff",
          });
          i++;
        }

        subresult[k] = {
          title: g.production_unit_name,
          data: [
            {
              name: "Kapasitas Terpakai",
              data: filled,
            },
            {
              name: "Sisa Kapasitas",
              data: unfilled,
            },
          ],
        };
      }

      if (data.min && data.max) {
        let annotate = {
          xaxis: [
            {
              x: data.min,
              strokeDashArray: 3,
              borderColor: "#C90000",
              label: {
                borderColor: "#C90000",
                style: {
                  color: "#fff",
                  background: "#C90000",
                },
                // text: 'Minimal ' + data.min + ' M3'
              },
            },
            {
              x: data.max,
              strokeDashArray: 3,
              borderColor: "#00AC4F",
              label: {
                borderColor: "#00AC4F",
                style: {
                  color: "#fff",
                  background: "#00AC4F",
                },
                // text: 'Maksimal ' + data.min + ' M3'
              },
            },
          ],
        };
        this.$set(this.barMaterialSingleOption, "annotations", annotate);
      }
      this.$nextTick(() => {
        this.$set(this.mainData, "material-single", subresult);
      });
      return result;
    },
    pieSales(data) {
      let colors = [];
      let temp = data.data.map((z) => {
        if (z.status_code == "PENDING") colors.push("#a6a6b7");
        else if (z.status_code == "CANCEL") colors.push("#ff0000");
        else if (z.status_code == "PROGRESS") colors.push("#2e93fa");
        else if (z.status_code == "SUCCESS" || z.status_code == "FINISH")
          colors.push("#66da26");
        else colors.push("#607d8b");
        return { name: z.status_code, y: z.quantity };
      });
      // console.log(temp);
      let result = [
        {
          name: "Sales Order",
          colorByPoint: true,
          innerSize: "70%",
          data: temp,
        },
      ];
      // colors: ["#2E93fA", "#66DA26", "#546E7A", "#E91E63", "#FF9800"],

      this.$set(this.pieHighChart, "series", result);
      this.$set(this.pieHighChart, "colors", colors);
      // console.log(this.pieHighChart);
      return result;
    },
    dataSelling(data) {
      let temp = this.splitIntoChunk(data.data, this.chunkSize);
      return temp;
    },
    dataFuel(data) {
      let temp = this.splitIntoChunk(data.data, this.chunkSize);
      return temp;
    },
    barEquipment(data) {
      let temp = data.data;
      let res = [];
      for (let i = 0; i < temp.length; i++) {
        const el = temp[i];
        let result = [
          {
            name: "Available",
            data: el.data.map((z) => {
              return { x: z.production_unit_name, y: z.available };
            }),
          },
          {
            name: "Breakdown",
            data: el.data.map((z) => {
              return { x: z.production_unit_name, y: z.brakdown };
            }),
          },
        ];
        res.push({ title: el.name, data: result });
      }
      return res;
    },
    splitIntoChunk(arr, chunkSize) {
      if (!chunkSize) return [arr];
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
  },
};
</script>

<style>
.VueCarousel,
.VueCarousel-wrapper,
.VueCarousel-inner {
  height: 100% !important;
  width: 100% !important;
}
.VueCarousel-pagination {
  text-align: right !important;
}
.main-container {
  position: relative;
  min-width: 1850px;
  max-width: 1850px;
  width: 1850px;
}
.main-container .content-inner {
  padding: 25px 0;
  /* height: 100vh; */
}
.main-container .row .mh-50 {
  min-height: 50%;
  max-height: 50%;
  height: 50%;
  overflow-y: hidden;
}
.apexcharts-title-text {
  font-size: 1.35rem !important;
  font-weight: 600 !important;
}
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #e0e8f0;
  border-radius: 0px 0px 20px 20px;
  padding: 1rem 2rem;
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/main-dashboard.vue